const state = {
  medicalCerts: [],
  currCert: null,
  tabIdx: 0
}

// actions
const actions = {
}

const getters = {
}

const mutations = {
  updateMedicalCerts (state, medicalCerts) {
    state.medicalCerts = medicalCerts
  },
  clearMedicalCerts (state) {
    state.medicalCerts = []
  },
  updateCurrCert (state, cert) {
    state.currCert = cert
  },
  updateTabIdx (state, tabIdx) {
    state.tabIdx = tabIdx
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
